import { useState } from 'react'
import VideoModal from './VideoModal'
import { GALLERY_VIDEOS } from './galleryData'
import { useGeneralSettings } from '../../../hooks/useGeneralSettings'

export default function MediaGallerySection() {
  const [activeEmbed, setActiveEmbed] = useState(null)
  const { settings } = useGeneralSettings()
  const youtubeUrl = typeof settings.youtube === 'string' ? settings.youtube.trim() : ''

  return (
    <section id="gallery" className="py-16 md:py-24 overflow-hidden font-normal uppercase" style={{ background: '#FDFAF6' }}>
      <div className="container px-6 mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-8">
          <div className="max-w-3xl w-full text-left">
            <span className="text-secondary text-[10px] tracking-[0.3em] uppercase mb-4 block font-normal">SACRED VISUALS</span>
            <h2 className="text-3xl md:text-5xl font-cinzel text-[#1C140A] leading-tight mb-6 font-normal uppercase">
              DIVINE MEDIA <span className="text-secondary">GALLERY</span>
            </h2>
            <p className="text-[#8B7355] leading-relaxed text-lg font-normal uppercase">
              EXPLORE THE PROFOUND TEACHINGS AND SPIRITUAL INSIGHTS SHARED BY MAHARAJ JI THROUGH HIGH-PRECISION VISUAL RECORDS.
            </p>
          </div>
          {youtubeUrl && (
            <a
              href={youtubeUrl}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center justify-center whitespace-nowrap bg-[#1C140A] py-2 rounded-full px-8 h-11 text-white hover:bg-[#C8922A] transition-all duration-500 font-normal uppercase tracking-widest text-[11px] shrink-0"
            >
              VIEW YOUTUBE CHANNEL
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4 ml-2">
                <path d="M2.5 17a24.12 24.12 0 0 1 0-10 2 2 0 0 1 1.4-1.4 49.56 49.56 0 0 1 16.2 0A2 2 0 0 1 21.5 7a24.12 24.12 0 0 1 0 10 2 2 0 0 1-1.4 1.4 49.55 49.55 0 0 1-16.2 0A2 2 0 0 1 2.5 17" />
                <path d="m10 15 5-3-5-3z" />
              </svg>
            </a>
          )}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {GALLERY_VIDEOS.map((video) => (
            <div
              key={video.id}
              className="group relative flex flex-col gap-5 bg-white rounded-3xl p-4 transition-all duration-500 hover:shadow-2xl hover:shadow-[#C8922A]/10 cursor-pointer"
              onClick={() => setActiveEmbed(video.embed)}
            >
              <div className="relative aspect-video rounded-2xl overflow-hidden bg-gray-100">
                <img src={video.image} alt={video.title} className="object-cover w-full h-full transition-transform duration-700 group-hover:scale-105 opacity-90" />
                <div className="absolute inset-0 flex items-center justify-center bg-[#C8922A]/20 opacity-100 lg:opacity-0 lg:group-hover:opacity-100 transition-opacity duration-500">
                  <div className="w-14 h-14 rounded-full bg-white/95 backdrop-blur-md flex items-center justify-center text-[#1C140A] shadow-2xl transition-transform duration-500 group-hover:scale-110">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6 ml-1">
                      <polygon points="6 3 20 12 6 21 6 3" />
                    </svg>
                  </div>
                </div>
              </div>
              <div className="space-y-3 px-2 pb-2">
                <div className="flex items-center gap-2">
                  <span className="text-[9px] font-normal uppercase tracking-[0.2em] text-secondary">{video.tag}</span>
                  <div className="h-px flex-1 bg-gray-200" />
                </div>
                <h3 className="text-lg font-cinzel text-[#1C140A] leading-tight line-clamp-2 group-hover:text-secondary transition-colors font-normal">{video.title}</h3>
                <div className="flex items-center justify-between pt-2">
                  <span className="text-[10px] font-normal uppercase tracking-widest text-[#1C140A]/40">SYNCHRONIZED MEDIA</span>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4 text-[#1C140A] opacity-20 group-hover:opacity-100 group-hover:translate-x-1 transition-all">
                    <path d="M5 12h14" />
                    <path d="m12 5 7 7-7 7" />
                  </svg>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <VideoModal embedUrl={activeEmbed} onClose={() => setActiveEmbed(null)} />
    </section>
  )
}
